module.exports = __webpack_public_path__ + "static/media/WarningIcon.24e1fa0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/WarningIcon.svg
// module id = 613
// module chunks = 0